import { gql, useQuery } from '@apollo/client';

// #36354 (PR #36979): the schedule Update quote would store for one line at an unsaved billing day.
export const GET_OFFER_PAYMENT_SCHEDULE = gql`
  query GetOfferPaymentSchedule(
    $offerId: ID!
    $option: String!
    $policyType: String!
    $billingDayOfMonth: Int!
    $megaDownPay: Boolean!
  ) {
    getOfferPaymentSchedule(
      offerId: $offerId
      option: $option
      policyType: $policyType
      billingDayOfMonth: $billingDayOfMonth
      megaDownPay: $megaDownPay
    ) {
      payments {
        date
        remainingMonthly
        transactionFee
        total
      }
      termTotal
      rateControlDateChangesOnUpdate
    }
  }
`;

/**
 * The preview as `{ schedule, termTotal }`, the shape the modal's table and summary read from a stored
 * schedule (the preview's rows are already the stored schedule's `PaymentsData`), plus whether Update
 * quote would move the rate control date to today, which can re-price the offer.
 */
export const toPaymentsData = (preview) =>
  preview
    ? {
        schedule: preview.payments,
        termTotal: preview.termTotal,
        rateControlDateChangesOnUpdate: preview.rateControlDateChangesOnUpdate
      }
    : null;

/**
 * The previewed schedule for one policy line at a billing day, or skipped when `skip` is set. Not cached:
 * the preview prices the offer as last saved, which Update quote changes.
 */
export const usePaymentSchedulePreview = ({ offerId, option, policyType, billingDayOfMonth, megaDownPay, skip }) => {
  const { data, loading, error, refetch } = useQuery(GET_OFFER_PAYMENT_SCHEDULE, {
    variables: { offerId, option, policyType, billingDayOfMonth, megaDownPay },
    skip: skip || !offerId || !billingDayOfMonth,
    fetchPolicy: 'no-cache'
  });
  return { preview: toPaymentsData(data?.getOfferPaymentSchedule), loading, error, refetch };
};
